(function () {
  var activeBA = null;

  function parseVariants(node) {
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function money(cents, fallback) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return fallback || '';
  }

  function shopifyRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
  }

  function updateCartIndicators(cartData) {
    if (!cartData) return;
    document.querySelectorAll('[data-incus-cart-link]').forEach(function (link) {
      var countType = link.getAttribute('data-incus-cart-count-type') || 'quantity';
      var count = countType === 'products' ? (cartData.items || []).length : Number(cartData.item_count || 0);
      var showZero = link.getAttribute('data-incus-cart-show-zero') !== 'false';
      var badge = link.querySelector('[data-incus-cart-count]');
      if (badge) {
        badge.textContent = String(count);
        if (count > 0 || showZero) badge.removeAttribute('hidden');
        else badge.setAttribute('hidden', 'hidden');
      }
      var label = link.getAttribute('data-incus-cart-label') || 'Cart';
      var countLabel = link.getAttribute('data-incus-cart-count-aria-label') || 'items in cart';
      link.setAttribute('aria-label', label + ': ' + count + ' ' + countLabel);
    });
  }

  function refreshCartIndicators() {
    if (!window.fetch || !document.querySelector('[data-incus-cart-link]')) return Promise.resolve();
    return fetch(shopifyRoot() + 'cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart refresh failed');
      return response.json();
    }).then(updateCartIndicators).catch(function () {});
  }

  function initVariantForms(root) {
    root.querySelectorAll('.incus-product-form').forEach(function (form) {
      if (form.dataset.incusVariantReady === 'true') return;
      form.dataset.incusVariantReady = 'true';
      var select = form.querySelector('[data-incus-variant-select]');
      var variants = parseVariants(form.querySelector('[data-incus-variants]'));
      var priceNodes = form.querySelectorAll('[data-incus-product-price]');
      var compareNodes = form.querySelectorAll('[data-incus-product-compare]');
      var addButtons = form.querySelectorAll('[data-incus-add-button]');
      var quantityInput = form.querySelector('[data-incus-quantity-input]');
      var optionButtons = form.querySelectorAll('[data-incus-quantity-option], [data-incus-variant-option]');

      function setOptionState(option, on) {
        var accent = option.getAttribute('data-incus-option-accent') || '#ED8D29';
        var selectedBg = option.getAttribute('data-incus-option-selected-bg') || 'rgba(237,141,41,.1)';
        option.setAttribute('aria-checked', on ? 'true' : 'false');
        option.style.background = on ? selectedBg : 'transparent';
        option.style.borderColor = on ? accent : 'rgba(228,229,229,.16)';
        var dot = option.querySelector('[data-incus-option-dot]');
        if (dot) {
          dot.style.borderColor = on ? accent : 'rgba(228,229,229,.16)';
          dot.style.background = on ? accent : 'transparent';
        }
      }

      function syncVariant() {
        var selectedVariantId = select ? Number(select.value) : null;
        optionButtons.forEach(function (candidate) {
          var variantId = candidate.getAttribute('data-incus-variant-option');
          if (variantId && selectedVariantId) setOptionState(candidate, Number(variantId) === selectedVariantId);
        });
        if (!select) return;
        var selected = select.options[select.selectedIndex];
        var id = Number(select.value);
        var variant = variants.find(function (candidate) { return Number(candidate.id) === id; });
        var available = selected ? selected.getAttribute('data-available') === 'true' : true;
        addButtons.forEach(function (button) {
          var availableLabel = button.getAttribute('data-label') || '';
          var labelPrefix = button.getAttribute('data-label-prefix');
          if (labelPrefix && variant && selected) {
            availableLabel = labelPrefix + ' · ' + money(variant.price, selected.getAttribute('data-price'));
          }
          button.disabled = !available;
          button.textContent = available ? availableLabel : button.getAttribute('data-soldout-label');
        });
        priceNodes.forEach(function (node) {
          if (variant && selected) node.textContent = money(variant.price, selected.getAttribute('data-price'));
        });
        compareNodes.forEach(function (node) {
          if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
            node.textContent = money(variant.compare_at_price, selected ? selected.getAttribute('data-compare-price') : '');
            node.hidden = false;
          } else {
            node.hidden = true;
          }
        });
      }

      optionButtons.forEach(function (option) {
        option.addEventListener('click', function () {
          if (quantityInput) quantityInput.value = option.getAttribute('data-incus-quantity-option') || '1';
          var variantOption = option.getAttribute('data-incus-variant-option');
          if (variantOption && select) {
            select.value = variantOption;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          optionButtons.forEach(function (candidate) {
            var sameGroup = !!candidate.getAttribute('data-incus-variant-option') === !!variantOption;
            if (sameGroup) setOptionState(candidate, candidate === option);
          });
        });
      });

      if (select) {
        select.addEventListener('change', syncVariant);
        syncVariant();
      } else {
        optionButtons.forEach(function (candidate) {
          setOptionState(candidate, candidate.getAttribute('aria-checked') === 'true');
        });
      }
    });
  }

  function initProductThumbs(root) {
    root.querySelectorAll('[data-incus-product-gallery]').forEach(function (gallery) {
      if (gallery.dataset.incusGalleryReady === 'true') return;
      gallery.dataset.incusGalleryReady = 'true';
      var stage = gallery.querySelector('[data-incus-main-image]');
      if (!stage) return;
      gallery.querySelectorAll('[data-incus-thumb-src]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-incus-thumb-src');
          var alt = thumb.getAttribute('data-incus-thumb-alt') || '';
          if (!src) return;
          stage.setAttribute('src', src);
          stage.setAttribute('alt', alt);
          gallery.querySelectorAll('[data-incus-thumb-src]').forEach(function (candidate) {
            candidate.setAttribute('aria-current', candidate === thumb ? 'true' : 'false');
          });
        });
      });
    });
  }

  function initAddonButtons(root) {
    root.querySelectorAll('[data-incus-addon-button]').forEach(function (button) {
      if (button.dataset.incusAddonReady === 'true') return;
      button.dataset.incusAddonReady = 'true';
      button.addEventListener('click', function () {
        var variantId = button.getAttribute('data-incus-addon-variant');
        if (!variantId || !window.fetch) return;
        var original = button.textContent;
        button.disabled = true;
        button.textContent = button.getAttribute('data-loading-label') || 'Adding...';
        fetch(shopifyRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: Number(button.getAttribute('data-incus-addon-quantity') || 1) })
        }).then(function (response) {
          if (!response.ok) throw new Error('Add failed');
          button.textContent = button.getAttribute('data-added-label') || 'Added';
          refreshCartIndicators();
        }).catch(function () {
          button.textContent = button.getAttribute('data-error-label') || original;
        }).finally(function () {
          setTimeout(function () {
            button.disabled = false;
            if (button.textContent !== original) button.textContent = original;
          }, 1800);
        });
      });
    });
  }

  function initIncus(root) {
    if (!root || root.dataset.incusReady === 'true') return;
    root.dataset.incusReady = 'true';

    root.querySelectorAll('[style-hover]').forEach(function (el) {
      var base = el.getAttribute('style') || '';
      var hover = el.getAttribute('style-hover') || '';
      el.addEventListener('mouseenter', function () { el.setAttribute('style', base + ';' + hover); });
      el.addEventListener('mouseleave', function () { el.setAttribute('style', base); });
    });

    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var nodes = Array.prototype.slice.call(root.querySelectorAll('[data-rise]'));
      var anim = { up: 'rise', left: 'riseL', right: 'riseR', scale: 'pop' };
      var pending = [];
      nodes.forEach(function (node) {
        if (node.getBoundingClientRect().top > window.innerHeight * 0.9) {
          node.style.opacity = '0';
          pending.push(node);
        }
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            el.style.animation = (anim[el.getAttribute('data-rise')] || 'rise') + ' .9s cubic-bezier(.16,1,.3,1) both';
            el.style.opacity = '';
            io.unobserve(el);
          });
        }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
        pending.forEach(function (node) { io.observe(node); });
        setTimeout(function () { pending.forEach(function (node) { if (node.style.opacity === '0') node.style.opacity = ''; }); }, 4000);
      }
    }

    root.querySelectorAll('[data-incus-ba]').forEach(function (wrap) {
      var clip = wrap.querySelector('[data-incus-ba-clip]');
      var handle = wrap.querySelector('[data-incus-ba-handle]');
      wrap.addEventListener('pointerdown', function (event) {
        activeBA = { wrap: wrap, clip: clip, handle: handle };
        if (wrap.setPointerCapture && event.pointerId != null) wrap.setPointerCapture(event.pointerId);
        setBA(event);
      });
    });

    var reelRail = root.querySelector('[data-incus-reel-rail]');
    var reelPrev = root.querySelector('[data-incus-reel-prev]');
    var reelNext = root.querySelector('[data-incus-reel-next]');
    if (reelRail && reelPrev) reelPrev.addEventListener('click', function () { reelRail.scrollBy({ left: -reelRail.clientWidth * 0.8, behavior: 'smooth' }); });
    if (reelRail && reelNext) reelNext.addEventListener('click', function () { reelRail.scrollBy({ left: reelRail.clientWidth * 0.8, behavior: 'smooth' }); });

    var apartRail = root.querySelector('[data-incus-apart-rail]');
    var apartBar = root.querySelector('[data-incus-apart-bar]');
    var openApart = 1;
    function syncApart() {
      if (!apartRail || !apartBar) return;
      var max = apartRail.scrollWidth - apartRail.clientWidth;
      var visible = apartRail.scrollWidth ? Math.min(1, apartRail.clientWidth / apartRail.scrollWidth) : 1;
      apartBar.style.width = (visible * 100) + '%';
      apartBar.style.left = (max > 0 ? (apartRail.scrollLeft / max) * (100 - visible * 100) : 0) + '%';
    }
    function nudgeApart(dir) {
      if (!apartRail) return;
      var card = apartRail.querySelector('[data-incus-apart-card]');
      var step = card ? card.getBoundingClientRect().width + 14 : apartRail.clientWidth * 0.8;
      apartRail.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
    function renderApart() {
      root.querySelectorAll('[data-incus-apart-card]').forEach(function (card) {
        var index = Number(card.getAttribute('data-incus-apart-card'));
        var on = openApart === index;
        card.setAttribute('aria-expanded', on ? 'true' : 'false');
        card.style.borderColor = on ? '#ED8D29' : 'rgba(228,229,229,.14)';
      });
      root.querySelectorAll('[data-incus-apart-panel]').forEach(function (panel) {
        panel.style.display = Number(panel.getAttribute('data-incus-apart-panel')) === openApart ? 'block' : 'none';
      });
      root.querySelectorAll('[data-incus-apart-icon]').forEach(function (icon) {
        var on = Number(icon.getAttribute('data-incus-apart-icon')) === openApart;
        icon.textContent = on ? '−' : '+';
        icon.style.background = on ? '#ED8D29' : '#E4E5E5';
      });
    }
    root.querySelectorAll('[data-incus-apart-card]').forEach(function (card) {
      card.addEventListener('click', function () {
        var index = Number(card.getAttribute('data-incus-apart-card'));
        openApart = openApart === index ? 0 : index;
        renderApart();
      });
    });
    if (apartRail) {
      apartRail.addEventListener('scroll', syncApart, { passive: true });
      window.addEventListener('resize', syncApart);
      syncApart();
    }
    var apartPrev = root.querySelector('[data-incus-apart-prev]');
    var apartNext = root.querySelector('[data-incus-apart-next]');
    if (apartPrev) apartPrev.addEventListener('click', function () { nudgeApart(-1); });
    if (apartNext) apartNext.addEventListener('click', function () { nudgeApart(1); });
    renderApart();

    initVariantForms(root);
    initProductThumbs(root);
    initAddonButtons(root);
  }

  function setBA(event) {
    if (!activeBA) return;
    var rect = activeBA.wrap.getBoundingClientRect();
    if (!rect.width) return;
    var pct = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
    if (activeBA.clip) activeBA.clip.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
    if (activeBA.handle) activeBA.handle.style.left = pct + '%';
  }
  function initAll(container) {
    (container || document).querySelectorAll('[data-incus-theme]').forEach(initIncus);
    initVariantForms(container || document);
    initProductThumbs(container || document);
    initAddonButtons(container || document);
    refreshCartIndicators();
  }
  window.IncusCart = window.IncusCart || {};
  window.IncusCart.refresh = refreshCartIndicators;
  document.addEventListener('incus:cart:refresh', refreshCartIndicators);
  document.addEventListener('cart:refresh', refreshCartIndicators);
  window.addEventListener('pointermove', setBA, { passive: true });
  window.addEventListener('pointerup', function () { activeBA = null; });
  window.addEventListener('pointercancel', function () { activeBA = null; });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
